import { render, staticRenderFns } from "./Globalvalue.vue?vue&type=template&id=7099277b&scoped=true"
import script from "./Globalvalue.vue?vue&type=script&lang=js"
export * from "./Globalvalue.vue?vue&type=script&lang=js"
import style0 from "./Globalvalue.vue?vue&type=style&index=0&id=7099277b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7099277b",
  null
  
)

export default component.exports